import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import itweekend from "assets/img/itweekend.png";
import Ads5 from "../../Main/Sections/Ads5.js";

import styles from "assets/jss/material-kit-react/views/mpm.js";
import { string } from "prop-types";

const useStyles = makeStyles(styles);

export default function MPMMainPage(props) {
    const classes = useStyles();

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
  
    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax small filter image={require("assets/img/bg14.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>

                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={itweekend} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>جشنواره فناوری اطلاعات ایران</h3>
                                        <div className={classes.description}>
                                        <p>
                                        جشنواره فناوری اطلاعات ایران،  ITWeekendرویدادی است که در آن افراد سر شناس در حوزه فناوری اطلاعات تجربیات و داستان موفقیت و شکست های خود را در قالب سخنرانی های کوتاه برای مخاطبین مطرح میکنند.
                                        </p>
                                        <p>
این رویداد با سابقه از سال 1394 تا کنون هفت دوره برگزارشده است ولی امکان برگزاری دوره هشتم این جشنواره با توجه به شرایط بیماری کرونا به صورت حضوری وجود نداشته و در نتیجه به صورت مجازی و همزمان با نمایشگاه مجازی ایران ایتکس برگزار خواهد شد.
</p>
                                        <p>
سخنرانی در ITWeekend الهام گرفته از کنفرانس های TEDx انجام می شود و پس از اتمام رویداد در قالب کلیپ های تدوین شده در سایت رسمی رویداد، سرویس های اشتراک ویدئو و شبکه های مجازی به اشتراک گذاشته می شوند.
</p>
                                        <p>
بنابراین پس از برگزاری چندین دوره از این جشنواره مجموعه ارزشمندی از سخنرانی های افراد سرشناس حوزه فناوری اطلاعات را خواهیم داشت.
</p>
                                        <p>
همچنین در حاشیه این سخنرانی ها پنل های تخصصی استارتاپ های موفق و شکست خورده برگزار میگردد.
</p>
                                        <p>
گزارش برگزاری ، سخنرانان و کلیپ های هفت دوره قبل در سایت رسمی جشنواره <a href='itweekend.ir' target="_black">itweekend.ir</a> موجود می باشد. 
</p>
                                        <p>
هدف اصلی از برگزاری جشنواره فناوری اطلاعات ایران، انتقال تجربه بزرگان این حوزه، ارائه دلایل موفقیت و شکست افراد سرشناس در این حوزه، ایجاد انگیزه برای راه اندازی کسب کار های نوین و خلاقانه، بررسی چالش های پیش روی استارتاپ ها موفق و نوپا می باشد.

                                         </p>
                                        </div>
                                    </div>
                                    <br />
                                    <p>
                                    <Button variant="outlined" target='_blank' href="http://itweekend.ir"  disableElevation>
                                    وبسایت جشنواره فناوری اطلاعات ایران
                                    </Button>
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>

                            {
        //<Ads2 />
      
      
     // <Ads5 />
      }
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2>جشنواره فناوری اطلاعات ایران چطور برگزار میشود؟</h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                    ITWeekend  الهام گرفته از کنفرانس های TEDx می باشد ولی با این تفاوت که در حوزه تخصصی فناوری اطلاعات و با احترام به ارزش‌های فرهنگی ایران اسلامی و در چارچوب قوانین کشور برگزار می‌شود.
                                    </p>
                                        <p>
در این رویداد که به صورت خودگردان برگزار می شود، افراد سرشناس، نوآوران و پیشوایان اندیشه و عمل در حوزه فناوری اطلاعات در قلب تهران گردهم فراخوانده شده تا ایده‌ها، تجربیات و ماجراهای خود را در قالب سخنرانی های کوتاه با مخاطبان به اشتراک بگذارند.
</p>
                                        <p>
جشنواره فناوری اطلاعات ایران با توجه به شایستگی و کیفیت بالای مخاطبین، حمایت علمی و معنوی دانشگاه صنعتی شریف و سازمان های دولتی مرتبط، سخنرانان برجسته و معتبری خواهد داشت در بین تمامی رویدادهای مشابه متمایز بوده و باعث ارتقای سطح رضایت مخاطبین و کیفیت همایش در سال های اخیر شده است.
</p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2>چه کسانی در جشنواره فناوری اطلاعات ایران شرکت میکنند؟</h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>                                    <ul>
                                        <li>
                                        یک مخترع که ابداعات و نوآوری‌هایش را هماهنگ با دنیای پیوسته در تغییر، به اشتراک می‌گذارد.
                                        </li>
                                        <li>
                                        یک آموزگار که علم گرانقدرش را به نحو تاثیرگذاری برای پیر و جوان به اشتراک می‌گذارد.
                                        </li>
                                        <li>
یک اعجوبه كه استعداد هایش منتظر شکوفایی است.
                                        </li>
                                        <li>
یک خردمند که بصیرتش تجربه گرانقدری برای دنیای امروز است.
                                        </li>
                                        <li>
یک  تغییرآفرین که کمک می‌کند آینده، آن طور که شایسته بودن است، شکل گیرد.
                                        </li>
                                        <li>
یک داستان‌سرای جذاب و پرشور و نشاط، که به خوبی با افراد ارتباط برقرار می‌کند.
                                        </li>
                                    </ul>
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2>ماموریت و اهداف جشنواره فناوری اطلاعات ایران</h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                    ماموریت جشنواره فناوری اطلاعات ایران ایجاد محیطی برای گردهمایی، گفتگو و هم¬‌افزایی برای نوآوران، نخبگان و صاحبان ایده در سطحی فراتر از مرزهای جغرافیایی می باشد.
                                    </p>
                                    <p>
همچنین شناسایی نخبگان و صاحبان ایده در راستای سرمایه گذاری مادی و حتی معنوی توسط حوزه های مختلف جهت پیشبرد اهداف علمی، فرهنگی، هنری، ورزشی از ماموریت های مهم این رویداد می باشد.
</p>
                                    <p>
از اهداف دیگر ITWeekend می توان به موارد زیر اشاره کرد:
                                    </p>
                                    <p>
                                                                            <ul>
                                        <li>
                                    روایت ایده‌ها برای تقویت انگیزه، خودباوری، اعتماد به‌نفس و الهام‌بخشی به جامعه
                                        </li>
                                        <li>
ایجاد بستر ارتباط، تبادل نظر و گفتگو میان نوآوران در ایران و سایر نقاط جهان
                                        </li>
                                        <li>
ایجاد بستری برای آفرینش و پرورش ایده‌های نو و بكر با برنامه‌های گوناگون
                                        </li>
                                        <li>
افزایش ارتباط ایرانیان خارج از کشور با سرزمین مادری
                                        </li>
                                        <li>
گردآوری نوآوران، طراحان و جستجوگران در سطح کشور و حتی جهانی، برای الهام‌بخشی به دیگران
                                        </li>
                                        <li>
ارتباط، مباحثه و مشارکت بین شرکت کنندگان
                                        </li>
                                    </ul>
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
